import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authAPI } from '../services/api'
import { EMAIL_SPAM_NOTE } from '../config/support'
import './Page.css'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [msg, setMsg] = useState(null)
  const [err, setErr] = useState(null)
  const [loading, setLoading] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setErr(null)
    setMsg(null)
    setLoading(true)
    try {
      const r = await authAPI.forgotPassword(email.trim())
      setMsg(r?.message || `If an account exists for that email, we sent instructions. ${EMAIL_SPAM_NOTE}`)
    } catch (e) {
      setErr(e.message || 'Something went wrong')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-container">
      <div className="dashboard-card" style={{ maxWidth: 440, margin: '2rem auto' }}>
        <h1 style={{ marginTop: 0 }}>Forgot password</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
          Enter your account email. If it exists, we will send a reset link. {EMAIL_SPAM_NOTE}
        </p>
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
          {msg && <p style={{ color: 'var(--success, #2d8a4e)', margin: 0 }}>{msg}</p>}
          {err && <p style={{ color: 'var(--error, #c44)', margin: 0 }}>{err}</p>}
          <div className="form-group">
            <label className="form-label" htmlFor="fp-email">Email</label>
            <input
              id="fp-email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <p style={{ marginTop: '1.5rem' }}>
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </div>
  )
}
